<template>
  <div>
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 v-if="ispreinscribir" class="text-center">Cambiar a Inscrito</h3>
    <h3 v-else-if="isgenerarplan" class="text-center">Generar plan de pagos</h3>
    <h3 v-else class="text-center">Formulario de inscripcion.</h3>
    <p class="text-center text-primary" style="margin-bottom: 0">
      <small class="center-block">
        <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco
        <span class="text-danger">*</span> son obligatorios
      </small>
    </p>
    <!-- <p class="text-righ" style="position: relative; top: 0px; left: 5px">
            <router-link :to="atras" :title="atras" class="btn btn-sm btn-link">
                <small><span class="glyphicon glyphicon-arrow-left"></span> Volver </small>
            </router-link>
        </p> -->

    <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
      <p class="text-primary" v-show="!ispreinscribir && !isgenerarplan">
        <b>IV. Datos de Inscripcion</b>
      </p>
      <div
        v-show="!ispreinscribir && !isgenerarplan"
        class="row"
        style="margin-top: 0; margin-bottom: 0; margin-left: 0px; margin-right: 0px; background: #ececec"
      >
        <div class="col-sm-10">
          <BuscarEstudiante :model="newEstudiante" :default="inscripcion" :inscripcion="inscripcion" />
          <b class="text-danger">
            <small>* Seleccione un estudiante para la inscripcion (Si no existe use el boton para registrarlo)</small>
          </b>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            outlined
            color="info"
            data-toggle="collapse"
            data-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            <v-icon>mdi-people</v-icon> Crear Nuevo Estudiante</v-btn
          >
        </div>
      </div>
      <br />

      <registro-estudiante-ck
        v-if="UNIDAD_NEGOCIO_ID === 3 || UNIDAD_NEGOCIO_ID === 4"
        :inscripcion="inscripcion"
        v-on:onnewregistro="onnewregistro"
      />
      <RegistroEstudiante v-else :inscripcion="inscripcion" v-on:onnewregistro="onnewregistro" />

      <p v-if="programa" class="text-center font-weight-bold my-0">
        <span> {{ formatCode(programa) }} </span> <v-spacer></v-spacer> <span>{{ getNomProgram() }}</span>
      </p>

      <div class="row" v-show="!ispreinscribir && !isgenerarplan">
        <div class="col-sm-6">
          <Usuarios :current="true" :model="inscripcion" />
          <small class="text-primary"> <span class="text-danger">*</span> Asesor de la inscripcion. </small>
        </div>
      </div>

      <!-- FALTA REVISAR COMO SE MANDAN LAS CUOTAS -->
      <div class="row" style="background-color: #e8f5fd">
        <div class="col-sm-12">
          <label>
            Observaciones <small>(opcional)</small>
            <textarea
              v-model.trim="inscripcionrest.observaciones"
              class="form-control"
              cols="80"
              rows="3"
              placeholder="Escriba alguna observacion sobre este participante..."
            ></textarea>
          </label>
        </div>
      </div>

      <div class="text-center" v-show="!ispreinscribir && !isgenerarplan">
        <label> <input type="checkbox" v-model="preinscripcion" /> Preinscribir </label>
        <small>(Al preinscribir no se define el plan de cuotas.)</small>
      </div>

      <div class="row" style="background-color: #cdfac2">
        <div class="col-sm-12" v-show="!preinscripcion">
          <p class="text-primary"><b> Plan de cuotas del estudiante:</b></p>
          <!-- <label> <input type="checkbox" v-model="inscripcionrest.tipo_pago"> En cuotas  </label> <small>(Desmarque para indicar que es al contado)</small> -->
          <div class="form-group row" style="margin-bottom: 0">
            <label for="staticEmail" class="col-sm-3 col-form-label" style="margin-bottom: 0; padding-bottom: 0"
              >Seleccione el plan de pagos para el estudiante:</label
            >
            <div class="col-sm-3" style="margin-bottom: 0">
              <select class="form-control" v-model="plansel">
                <option :key="ind" v-for="(p, ind) in planes" :value="p">{{ p.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="mb-4">
            <small class="text-danger">
              <b>NOTA:</b> En el caso de no existir el plan de pagos adecuado, contacte con la parte academica para
              registrar el plan necesario. <b>Tomar en cuenta:</b> No puede editar los montos de cada concepto, si puede
              editar la cantidad de cuotas y fechas, pero la suma de todas las cuotas debe ser igual al monto del
              concepto.
            </small>
          </div>

          <v-alert>
            <span v-if="xpromos.length > 1" class="blue--text">
              Hay {{ xpromos.length }} promociones disponibles, seleccione una:
            </span>
            <v-combobox
              v-model="xpromo"
              :items="xpromos"
              item-text="nombre"
              v-if="planseleccionado.plan_cobro_programa_id && planvalidodescuento"
              item-value="id"
              :loading="loading_promo"
              :label="xpromo ? 'Promocion seleccionada:' : 'seleccione la promocion:'"
              class="white px-3"
              prepend-inner-icon="mdi-basket"
              color="purple"
              hide-details
              clearable
            ></v-combobox>
            <div v-if="xpromo && planseleccionado.plan_cobro_programa_id">
              <p class="mb-0 ml-4 mt-2"><b>Descripcion: </b> {{ xpromo.descripcion }}</p>
              <p class="mb-0 ml-4"><b>Creado por: </b> {{ xpromo.creado_por }}</p>
              <p class="mb-0 ml-4"><b>Aprobado por: </b> {{ xpromo.aprobado_por }}</p>
              <p class="mb-0 ml-4"><b>Fecha inicio: </b> {{ xpromo.fecha_inicio }}</p>
              <p class="mb-0 ml-4"><b>Fecha finalizacion: </b> {{ xpromo.fecha_fin }}</p>
              <v-divider class="my-1"></v-divider>
              <p class="mb-0 ml-6" v-for="(d, ind) in xpromo.detalle_promocion" :key="ind">
                <b class="purple--text"> {{ d.nombre_concepto }}: </b> {{ d.valor_descuento }}
                {{ d.is_porcentaje ? '%' : 'Bs.' }} de descuento.
              </p>
            </div>
          </v-alert>

          <div key="ind" vv-for="(p, ind) in planes">
            <div
              vv-show="p.plan_cobro_programa_id == planseleccionado.plan_cobro_programa_id"
              v-for="(r, ind) in planseleccionado.cobros"
              :key="ind"
            >
              <!-- <template v-if="!r.opcional"> -->
              <div class="row" style="margin-bottom: 4px">
                <div class="col-sm-3 text-primary">
                  <b> Monto de: {{ r.nombre }} </b> <br />
                  <div v-if="r.monto_original">
                    <p class="mb-0 purple--text"><b>Monto original:</b> {{ r.monto_original }}</p>
                    <p class="mb-0 purple--text">
                      <b>Monto a descontar:</b> {{ r.valor_descuento }} {{ r.is_porcentaje ? '%' : 'Bs.' }}
                    </p>
                  </div>
                  <input
                    @change="cambiocuotas(r)"
                    :disabled="true"
                    title="No puede editar los montos ya asignados, debe cambiar a otro plan"
                    style="display: inline-block"
                    class="xinput input-sm"
                    maxlength="5"
                    type="number"
                    v-model.number="r.monto"
                    placeholder="monto"
                    required="true"
                  />
                </div>
                <div class="col-sm-2">
                  <b> Cantidad de Cuotas </b> <br />
                  <input
                    @change="cambiocuotas(r)"
                    class="form-control input-sm"
                    maxlength="5"
                    type="number"
                    v-model.number="r.cuotas"
                    placeholder="cuotas"
                    required="true"
                  />
                </div>
                <div class="col-sm-3 col-lg-3 pt-10">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <label v-bind="attrs" v-on="on">
                        <input type="checkbox" v-model="autoasigfechas" /> Auto cambiar fechas
                      </label>
                    </template>
                    <span>
                      Cada cambio de fecha regenera a las demas, para evitar este efecto desactive esta casilla
                    </span>
                  </v-tooltip>
                </div>
              </div>

              <div class="row" style="margin-bottom: 4px" v-for="(plan, ind2) in r.pagos" :key="ind2">
                <div class="col-sm-2 col-sm-offset-3 pt-0 pb-0">
                  <b> # {{ plan.nro_cuota }} </b>
                  <input
                    style="max-width: 110px"
                    class="xinput input-sm"
                    maxlength="5"
                    type="number"
                    v-model.number="plan.monto"
                    placeholder="monto"
                    required="true"
                  />
                </div>
                <div class="col-sm-3 pt-0 pb-0">
                  <Fecha
                    :model="plan"
                    :xplanes="planseleccionado"
                    :xautogenerarfechas="autoasigfechas"
                    :valueto="'fecha_pago'"
                    :default="plan.xfecha_pago"
                    :datenewrest="true"
                    title="Fecha prevista de pago"
                  />
                </div>
              </div>
              <!-- </template> -->
            </div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <p v-if="programa" class="text-center font-weight-bold my-0">
        <span> {{ formatCode(programa) }} </span> <v-spacer></v-spacer> <span>{{ getNomProgram() }}</span>
      </p>
      <p class="text-center text-danger">{{ msg }}</p>
    </form>

    <div class="text-center">
      <div style="display: inline-block" v-show="loading" class="loader"></div>
    </div>
    <button
      v-if="!ispreinscribir && !isgenerarplan"
      class="center-block btn btn-sm btn-success"
      :disabled="loading"
      @click="validardatosrest()"
    >
      {{ preinscripcion ? 'Preinscribir' : 'Realizar inscripcion' }}
    </button>
    <button
      v-else-if="isgenerarplan"
      class="center-block btn btn-sm btn-warning"
      :disabled="loading"
      @click="validarcambioinscrito(0)"
    >
      Generar plan de pagos
    </button>
    <button v-else class="center-block btn btn-sm btn-success" :disabled="loading" @click="validarcambioinscrito(1)">
      Realizar cambio a inscrito
    </button>

    <notifications group="auth" position="bottom right" />
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>
  </div>
</template>
<script>
  import Usuarios from '@/components/AUsuariosActivos.vue';
  import BuscarEstudiante from '@/components/ABuscarEstudiante.vue';
  import Alertas from '@/components/AAlertas.vue';
  import RegistroEstudiante from '@/components/ARegEstudiante.vue';
  import RegistroEstudianteCk from './ciberkids/RegNewStudent.vue';
  import Fecha from '@/components/AFechax.vue';
  // import { generarContrato } from '@/components/generar-contrato.js';
  import { isNullObject, error } from '@/components/Utils.js';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        remote_plan: [],
        api_rest: process.env.VUE_APP_API_REST,
        activo: true,
        //preinscribir: true,
        autoasigfechas: true,
        datosvalidos: true,
        msg: '',
        modelinscrito: {},
        idNewInscripcion: 0,
        programa: {},
        cuotas_validas: { valido: true },
        atras: 'programas',
        loading_promo: false,
        preinscripcion: false,
        newEstudiante: {
          iddepartamento: null,
          idciudad: null,
          idprofesion: null,
          iduniversidad: null,
          idempresa: null,
          idgrado: null,
        },
        inscripcion: {
          idestudiante: null,
          tipopago: false,
          idprograma: null,
          idusuario: null,
          matricula: { monto: -1, fecha: '' },
          certificacion: { monto: -1, fecha: '' },
          monto: { monto_colegiatura: -1, cuotas: null, fecha_ins: null },
          observaciones: null,
        },
        matriculaCreada: { id: -1 },
        cuotas_por_pagar: [],
        cuotas: [],

        loading: false,
        cuotasfalse: 0,
        planseleccionado: { plan_cobro_programa_id: null, cobros: [] },
        plansel: { plan_cobro_programa_id: null },
        inscripcionrest: {
          programa_id: null,
          estudiante_id: null,
          asesor_id: null,
          observaciones: null,
          registrado_por: 1,
          tipo_pago: true, // true  a cuotas, false al contado
          plan_pagos: [],
        },
        plan_depagos: [],
        cobros_programa: [],
        ispreinscribir: false,
        isgenerarplan: false,
        ispreinscrito: { id: null },
        isgenerarplaninscrito: { id: null },

        planes: [],
        xpromos: [],
        xpromo: null,
        planvalidodescuento: false,
      };
    },
    components: {
      Usuarios,
      BuscarEstudiante,
      Alertas,
      RegistroEstudiante,
      RegistroEstudianteCk,
      Fecha,
    },
    watch: {
      UNIDAD_NEGOCIO_ID() {},
      plansel: function() {
        this.aplicarPromocion();
      },
      xpromo: function() {
        this.aplicarPromocion();
      },
    },
    computed: {
      ...mapState({
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        store_inscripcion: (state) => state.inscripcion.value,
      }),
    },
    methods: {
      lisCuotas() {
        // window.console.log(this.inscripcion);
        //   if (this.inscripcion.monto.cuotas > 2) this.inscripcion.tipopago = true;
        //   else this.inscripcion.tipopago = false;
        // window.console.log( "   ",this.inscripcion.tipopago );
      },
      aplicarPromocion() {
        let obj = JSON.stringify(this.plansel);
        let plan = JSON.parse(obj);
        this.planvalidodescuento = true;
        let planvalidodes =
          plan.nombre != 'PLAN AL CRÉDITO' &&
          plan.nombre != 'PLAN AL CONTADO' &&
          plan.nombre != 'PLAN NORMAL CURSO' &&
          plan.nombre != 'PLAN CREDITO POSGRADOS' &&
          plan.nombre != 'PLAN CONTADO POSGRADOS' &&
          plan.nombre != 'PLAN NORMAL CURSO' &&
          plan.nombre != 'PLAN AL CONTADO FORMACIÓN CONTINUA' &&
          plan.nombre != 'PLAN AL CONTADO MANEJO DE PAQUETES' &&
          plan.nombre != 'PLAN PROMOCIONAL CURSO';
        if (planvalidodes) {
          this.xpromo = null;
          this.planvalidodescuento = false;
          if (this.xpromos.length > 0) {
            this.$root.$notify.show(`La promocion no es aplicable a este tipo de plan [${plan.nombre}]`, {
              color: 'danger',
              x: 'left',
            });
          }
        }
        window.console.log('objobjobjobj', plan.nombre);
        let idsede = this.$store.state.CARGO.idsede;
        if (this.xpromo && plan.cobros && !planvalidodes) {
          let vue = this;
          this.xpromo.detalle_promocion.forEach((x) => {
            let cobro = plan.cobros.find((c) => c.concepto_id == x.concepto_pago_id);
            if (cobro) {
              let monto_a_descontar = 0;
              if (x.is_porcentaje) {
                monto_a_descontar = (parseInt(x.valor_descuento) * cobro.monto) / 100;
                // monto_a_descontar += 0.5;
                if (idsede != 17) {
                  // distinto al CAS
                  let decimales = monto_a_descontar - (parseInt(monto_a_descontar) / 2) * 2;
                  monto_a_descontar = parseInt(monto_a_descontar);
                  if (decimales >= 0.6) monto_a_descontar += 1;

                  window.console.log('decimales:', decimales, (parseInt(x.valor_descuento) * cobro.monto) / 100);
                  window.console.log('monto_a_descontar', monto_a_descontar);
                }
              } else monto_a_descontar = parseInt(x.valor_descuento);
              cobro.monto_original = cobro.monto;
              cobro.monto = cobro.monto - monto_a_descontar;
              /* if (x.is_porcentaje && idsede != 17 ) { // distinto al CAS
                cobro.monto = Math.ceil(cobro.monto);
              } */
              cobro.valor_descuento = x.valor_descuento;
              cobro.is_porcentaje = x.is_porcentaje;
              // window.console.log('monto_a_descontar', monto_a_descontar);
              vue.cambiocuotas(cobro);
            }
          });
          window.console.log('planseleccionado', plan);
        }
        if (plan.cobros) {
          plan.cobros.forEach((co) => {
            co.xmaxcuotas = co.cuotas;
          });
        }

        let o = JSON.stringify(plan);
        this.planseleccionado = JSON.parse(o);
        let vue = this;
        setTimeout(() => {
          vue.planseleccionado.cobros.forEach((x) => {
            vue.cambiocuotas(x);
          });
        }, 300);
        // this.planseleccionado = plan;
      },
      /*xgenerarContrato() {
        if (this.inscripcion.idestudiante == null) {
          this.$notify(error('Contrato', 'Seleccione un Estudiante.'));
          return;
        }
        var obj = window.Object.assign({}, this.inscripcion);
        obj.matricula.saldo = obj.matricula.monto;
        generarContrato(
          this.programa,
          this.cuotas,
          this.inscripcion.idestudiante,
          { monto_colegiatura: obj.monto.monto_colegiatura, monto_matricula: obj.matricula.monto },
          obj,
        );
      },*/
      getNomProgram() {
        if (this.programa == null) return '?';
        return this.programa.nombre_compuesto;
      },
      validardatosrest() {
        this.msg = '';
        //window.console.log('JAJAJAJAJAJ');
        //window.console.log("LOG:::::::::::", this.planseleccionado.cobros);
        const vue = this;
        let userid = this.$store.state.DATA_USER.id;
        var obj = window.Object.assign({}, this.inscripcionrest);

        if (!this.inscripcion.idestudiante) {
          this.msg = 'Seleccione un estudiante';
          return;
        }
        if (!this.inscripcion.idusuario) {
          this.msg = 'Seleccione un asesor';
          return;
        }
        if (!this.programa.id) {
          this.msg = 'No hay programa seleccionado, salga y vuelva a realizar la inscripcion.';
          return;
        }
        if (obj.observaciones && obj.observaciones.length < 5) {
          this.msg = 'La observacion es demasiado corta, ingrese al menos 5 caracteres.';
          return;
        }
        if (!obj.observaciones) delete obj.observaciones;

        obj.programa_id = this.programa.id;
        obj.estudiante_id = this.inscripcion.idestudiante.id;
        obj.asesor_id = this.inscripcion.idusuario.id;
        obj.registrado_por = userid;

        obj.plan_pagos = [];
        var cuotasvalidas = true;
        let msg_cuotas_val = '';
        if (!vue.preinscripcion && !vue.planseleccionado.plan_cobro_programa_id) {
          vue.msg = 'Seleccione un plan de pagos antes de continuar.';
          return;
        } else if (vue.planseleccionado.plan_cobro_programa_id) {
          obj.plan_cobro_programa_id = vue.planseleccionado.plan_cobro_programa_id;

          // 17 = C.A.S
          let idsede = this.$store.state.CARGO.idsede;

          this.planseleccionado.cobros.forEach(function(e) {
            let xmonto = 0;
            window.console.log('LOG:::::::::::', e.pagos.length, e);
            if (e.pagos.length > e.xmaxcuotas) {
              msg_cuotas_val = `El numero de cuotas a asignar(${e.pagos.length}) excede el maximo permitido(${e.xmaxcuotas}) definidoo en el programa para el concepto: ${e.nombre}, reduzca la cantidad de cuotas.`;
            }
            e.pagos.forEach(function(p) {
              // window.console.log("LOG:::::::::::", p);
              xmonto += p.monto;
              obj.plan_pagos.push({
                cobro_programa_id: p.cobro_programa_id,
                monto: p.monto,
                nro_cuota: p.nro_cuota,
                fecha_pago: p.fecha_pago,
              });
            });
            let po = vue.cobros_programa.find((x) => x.cobro_programa_id == e.cobro_programa_id);
            let pagooriginal = window.Object.assign({}, po);
            // window.console.log('JEJEJEJEEJ:', xmonto, pagooriginal);
            // no se puede hacer cambios en los montos
            // por eso hay plan de pagos
            if (idsede == 17) {
              xmonto = xmonto.toFixed(2);
              pagooriginal.monto = pagooriginal.monto.toFixed(2);
              //window.console.log( 'JEJEJEJEEJ:',xmonto);
            }

            //window.console.log('MMMMMMMMMM>>', diferencia,tolerancia, diferencia > tolerancia);
            window.console.log('xpromo:::::::', vue.xpromo);
            if (!vue.xpromo) {
              let diferencia = pagooriginal.monto - xmonto;
              let tolerancia = 0.04;
              if (diferencia > tolerancia) {
                cuotasvalidas = false;
                vue.msg = `Las cuotas de ${e.nombre} (${xmonto}bs), no debe ser diferente a los ${pagooriginal.monto}Bs definido en el programa.`;
              }
            }
          });
          if (!cuotasvalidas) return;
        }

        if (msg_cuotas_val) {
          vue.msg = msg_cuotas_val;
          return;
        }
        // line for print
        // window.console.log( JSON.stringify(obj,null,4) )

        this.dialogoconfirm(obj);
      },
      getprogramarest(idprograma) {
        this.loading = true;
        const vue = this;
        let myHeaders = getheadersrest();
        var requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

        let urlacademico = `${this.api_rest}/esam/programa/id/${idprograma}`;
        fetch(urlacademico, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            //window.console.log('PROGRMA:', result);
            if (!result) {
              vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO OBTENER DATOS DEL PROGRAMA.';
            } else if (result.error) {
              vue.msg = result.error;
            } else {
              vue.btntexto = 'Actualizar datos del programa';
              vue.titletexto = 'Actualizar datos del programa';
              vue.inscripcionrest.plan_pagos = [];
              if (result.planes) {
                var indicep = 0;
                result.planes.forEach(function(p) {
                  //window.console.log(">>>", p,urlacademico);
                  p.cobros = p.cobros.filter(function(cobro) {
                    return !cobro.opcional;
                  }); // eliminamos los opcionales
                  if (p.estado) vue.generarplan(p, indicep);
                });
              }
              if (vue.planes.length == 0) {
                vue.msg =
                  'Este programa no tiene asignado ningun plan de pagos, debe ir a editar el programa y asignar los planes.';
              }
              vue.getPromo(idprograma);
            }
            vue.loading = false;
          })
          .catch(() => {
            // window.console.log('error', error);
            vue.loading = false;
          });
      },
      generarplan(plan, indicep) {
        const vue = this;
        let date = new Date();
        let xidglobal = 0;

        // 17 = C.A.S
        let idsede = this.$store.state.CARGO.idsede;
        let totalplan = 0;
        let diferencia = 0;

        //window.console.log('>>>>',idsede);

        plan.cobros.forEach(function(e, indicex) {
          let cp = window.Object.assign({}, e);
          cp.znombre = plan.nombre + '_' + e.nombre;
          cp.planid = plan.plan_cobro_programa_id;
          vue.cobros_programa.push(cp);

          if (e.estado) {
            let submonto;
            if (idsede == 17) {
              //submonto = (e.monto / e.cuotas);
              submonto = Math.round((e.monto / e.cuotas) * 100) / 100;
            } else {
              submonto = parseInt(e.monto / e.cuotas);
            }
            let pad = e.monto - submonto * e.cuotas;
            let indice = 1;
            const pm2 = [];

            for (let i = 0; i < e.cuotas; i++) {
              let xmonto = submonto;
              if (i == 0 && idsede != 17) xmonto += pad;
              //window.console.log('PAD::::',pad,submonto,xmonto);

              if (i > 0) date.setDate(15);
              let d = date.getDate();
              let m = date.getMonth() + 1;
              let a = date.getFullYear();
              if (d < 10) d = '0' + d;
              if (m < 10) m = '0' + m;
              let fecha = a + '-' + m + '-' + d;
              date.setMonth(date.getMonth() + 1);

              pm2.push({
                cobro_programa_id: e.cobro_programa_id,
                monto: xmonto,
                nro_cuota: indice,
                estado: e.estado,
                xnombre: e.nombre,
                fecha_pago: null,
                xfecha_pago: fecha,
                saldo: xmonto,
                xid: indicex + indicep,
                xidglobal: xidglobal++,
              });
              totalplan += xmonto;
              indice++;
              indicep++;
            }
            e.pagos = pm2;

            if (idsede == 17) {
              totalplan = Math.round(totalplan * 100) / 100;
              diferencia = Math.round((e.monto - totalplan) * 100) / 100;
              e.pagos[e.pagos.length - 1].monto += diferencia;

              window.console.log('>>>diferencia', diferencia);
            }
          } else {
            vue.cuotasfalse += 1;
          }
        });
        //window.console.log('totalplan:::',totalplan);
        vue.planes.push(plan);
        //window.console.log("plan>", plan);
      },
      generarnumeroscuotas(e) {
        const vue = this;
        let idsede = this.$store.state.CARGO.idsede;
        let submonto;
        if (idsede == 17) {
          //submonto = (e.monto / e.cuotas);
          submonto = Math.round((e.monto / e.cuotas) * 100) / 100;
        } else {
          submonto = parseInt(e.monto / e.cuotas);
        }
        let pad = e.monto - submonto * e.cuotas;
        let indice = 1;
        let totalplan = 0;
        let diferencia = 0;
        this.loading = true;
        // 17 = C.A.S
        //const pm2 = [];
        setTimeout(function() {
          //setimeout sino la fecha no carga :(
          e.pagos = [];
          for (let i = 0; i < e.cuotas; i++) {
            let xmonto = submonto;
            if (i == 0 && idsede != 17) {
              xmonto += pad;
              //xmonto = Math.floor(xmonto);
              //xmonto = (parseInt(xmonto)*100) / 100;
            }
            let date = new Date();
            date.setMonth(date.getMonth() + i);
            if (i > 0) date.setDate(15);
            let d = date.getDate();
            let m = date.getMonth() + 1;
            let a = date.getFullYear();
            if (d < 10) d = '0' + d;
            if (m < 10) m = '0' + m;
            let fecha = a + '-' + m + '-' + d;

            e.pagos.push({
              cobro_programa_id: e.cobro_programa_id,
              monto: xmonto,
              nro_cuota: indice,
              estado: e.estado,
              xnombre: e.nombre,
              fecha_pago: null,
              xfecha_pago: fecha,
              saldo: xmonto,
            });
            totalplan += xmonto;
            indice++;
            vue.loading = false;
          }
          totalplan = Math.round(totalplan * 100) / 100;
          diferencia = Math.round((e.monto - totalplan) * 100) / 100;
          window.console.log('diferencia::::', diferencia);
          if (idsede == 1) {
            e.pagos[0].monto += diferencia;
            // e.pagos[0].monto = Math.ceil(e.pagos[0].monto);
          } else {
            e.pagos[e.pagos.length - 1].monto += diferencia;
          }
          //window.console.log('totalplan::::::',totalplan,diferencia);
        }, 300);

        //e.pagos = pm2;
      },

      dialogoconfirm(obj) {
        const vue = this;
        vue.loading = true;
        /* window.console.log(JSON.stringify(obj, null, 4));
        window.console.log(this.planseleccionado); */
        let txt = '';
        obj.plan_pagos.forEach((x) => {
          if (!x.monto || x.monto < 0) txt = `El monto no es valido: ${x.monto}.`;
        });

        if (this.planseleccionado && this.planseleccionado.cobros) {
          this.planseleccionado.cobros.forEach((x) => {
            if (!x.monto || x.monto < 0) txt = `El monto de ${x.nombre}: ${x.monto} no es valido.`;
          });
        }

        if (txt) {
          this.msg = txt;
          return;
        }

        this.$dialog
          .confirm(this.$store.state.alertmsg)
          .then(function() {
            if (vue.preinscripcion) vue.preinscribir(obj);
            else vue.inscribir(obj);
          })
          .catch(function() {
            vue.loading = false;
          });
      },
      preinscribir(obj) {
        this.loading = true;
        const vue = this;
        delete obj.plan_pagos;
        delete obj.tipo_pago;

        /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/
        let myHeaders = getheadersrest();
        var raw = JSON.stringify(obj);
        var requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

        let urlacademico = `${this.api_rest}/api/esam/preinscripcion`;
        fetch(urlacademico, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // window.console.log('PREINS:',result);
            if (!result) {
              vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO PREINSCRIBIR.';
            } else if (result.error) {
              vue.msg = result.error;
            } else {
              if (result.enrollment_id) {
                vue.msg = 'Pre inscrito correctamente, ID: ' + result.enrollment_id;
              } else {
                vue.msg = 'ERROR: ' + result;
              }
            }
            vue.loading = false;
          })
          .catch(() => {
            // window.console.log('error', error);
            vue.loading = false;
          });
      },
      inscribir(obj) {
        this.loading = true;
        const vue = this;

        /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/
        let myHeaders = getheadersrest();
        if (this.xpromo && this.xpromo.id) obj.promocion_id = this.xpromo.id;
        window.console.log(JSON.stringify(obj, null, 4));
        var raw = JSON.stringify(obj);
        var requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

        let urlacademico = `${this.api_rest}/api/esam/inscripcion`;
        fetch(urlacademico, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // window.console.log('GET PROGRMA:',result);
            if (!result) {
              vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO INSCRIBIR.';
            } else if (result.error) {
              vue.msg = result.error;
            } else {
              if (result.enrollment_id) {
                vue.msg = 'Inscrito correctamente, ID: ' + result.enrollment_id;
              } else {
                vue.msg = 'ERROR: ' + result;
              }
            }
            vue.loading = false;
          })
          .catch(() => {
            // window.console.log('error', error);
            vue.loading = false;
          });
      },
      cambiocuotas(cuota) {
        // window.console.log( '>>>',cuota );
        cuota.pagos = [];
        this.generarnumeroscuotas(cuota);
      },
      validarcambioinscrito(flag) {
        this.msg = '';
        const vue = this;
        let userid = this.$store.state.DATA_USER.id;
        var obj = window.Object.assign({}, this.inscripcionrest);
        if (obj.observaciones && obj.observaciones.length < 5) {
          this.msg = 'La observacion es demasiado corta, ingrese al menos 5 caracteres.';
          return;
        }
        if (!obj.observaciones) delete obj.observaciones;

        obj.plan_pagos = [];
        var cuotasvalidas = true;
        if (!vue.planseleccionado.plan_cobro_programa_id) {
          if (vue.isgenerarplan)
            vue.msg = 'Seleccione un plan de pagos antes de generar el plan de pagos del estudiante.';
          else vue.msg = 'Seleccione un plan de pagos antes de realizar el cambio a inscrito.';
          return;
        } else if (vue.planseleccionado.plan_cobro_programa_id) {
          obj.plan_cobro_programa_id = vue.planseleccionado.plan_cobro_programa_id;

          // 17 = C.A.S
          let idsede = this.$store.state.CARGO.idsede;

          this.planseleccionado.cobros.forEach(function(e) {
            let xmonto = 0;
            e.pagos.forEach(function(p) {
              xmonto += p.monto;
              obj.plan_pagos.push({
                cobro_programa_id: p.cobro_programa_id,
                monto: p.monto,
                nro_cuota: p.nro_cuota,
                fecha_pago: p.fecha_pago,
              });
            });
            let pagooriginal = vue.cobros_programa.find((x) => x.cobro_programa_id == e.cobro_programa_id);
            // window.console.log( 'JEJEJEJEEJ:',xmonto,e,vue.planseleccionado,vue.cobros_programa );
            // no se puede hacer cambios en los montos
            // por eso hay plan de pagos
            // xmonto = xmonto.toFixed(2);
            // pagooriginal.monto = pagooriginal.monto.toFixed(2);
            // window.console.log( 'JEJEJEJEEJ:',xmonto);

            if (idsede == 17) {
              xmonto = xmonto.toFixed(2);
              pagooriginal.monto = pagooriginal.monto.toFixed(2);
              //window.console.log( 'JEJEJEJEEJ:',xmonto);
            }
            if (!vue.xpromo) {
              let diferencia = pagooriginal.monto - xmonto;
              let tolerancia = 0.04;
              if (diferencia > tolerancia) {
                cuotasvalidas = false;
                vue.msg = `Las cuotas de ${e.nombre} (${xmonto}bs), no debe ser diferente a los ${pagooriginal.monto}Bs definido en el programa.`;
              }
            }
          });
          if (!cuotasvalidas) return;
        }

        // window.console.log("<--->", this.ispreinscrito, this.programa);

        // window.console.log("this.store_inscripcion",this.store_inscripcion);
        let body = {
          inscripcion_id: this.store_inscripcion.id, // aqui taba el error
          programa_id: this.programa.id,
          estudiante_id: this.programa.estudiante_id,
          asesor_id: this.ispreinscrito.asesor.id,
          registrado_por: userid,
          tipo_pago: true, // true  a cuotas, false al contado
          plan_cobro_programa_id: this.planseleccionado.plan_cobro_programa_id,
          plan_pagos: obj.plan_pagos,
        };
        if (obj.observaciones) body.observaciones = obj.observaciones;

        window.console.log(window.stringifyObject(body), flag);
        this.xactualizarpersona(this.programa.estudiante_id);

        vue.loading = true;
        this.$dialog
          .confirm(this.$store.state.alertmsg)
          .then(function() {
            if (flag == 0) vue.generarplanplagos(body);
            else vue.cambioinscrito(body);
          })
          .catch(function() {
            vue.loading = false;
          });
      },
      cambioinscrito(obj) {
        this.loading = true;
        const vue = this;
        //delete obj.plan_pagos;
        //delete obj.tipo_pago;

        /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/
        let myHeaders = getheadersrest();
        var raw = JSON.stringify(obj, null, 4);
        var requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

        window.console.log(raw, obj);

        let urlacademico = `${this.api_rest}/api/esam/preinscripcion`;
        window.console.log(urlacademico);
        fetch(urlacademico, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // window.console.log('CAMBIOINS:',result);
            if (!result) {
              vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO PREINSCRIBIR.';
            } else if (result.error) {
              vue.msg = result.error;
            } else {
              if (result.enrollment_id) {
                vue.msg = 'Cambio realizado correctamente, ID: ' + result.enrollment_id;
                sessionStorage.removeItem('xpreinscrito');
                vue.$router.back();
              } else if (result.result) {
                vue.msg = 'Cambio realizado correctamente.';
                sessionStorage.removeItem('xpreinscrito');
                vue.$router.back();
              } else {
                vue.msg = 'ERROR: ' + result;
              }
            }
            vue.loading = false;
          })
          .catch(() => {
            // window.console.log('error', error);
            vue.loading = false;
          });
      },
      generarplanplagos(obj) {
        this.loading = true;
        const vue = this;
        //delete obj.plan_pagos;
        //delete obj.tipo_pago;

        /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/
        let myHeaders = getheadersrest();
        var raw = JSON.stringify(obj, null, 4);
        var requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };
        let urlacademico = `${this.api_rest}/api/esam/inscripcion/generate/plan`;
        window.console.log(urlacademico);

        if (this.remote_plan.length) {
          const url = `${this.api_rest}/api/esam/inscripcion/plan/eliminar`;
          xaxios
            .post(url, { inscripcion_id: this.programa.inscripcion_id })
            .then(() => {
              fetch(urlacademico, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                  // window.console.log('GENERAPLAN:',result);
                  if (!result) {
                    vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO Generar el plan.';
                  } else if (result.error) {
                    vue.msg = result.error;
                  } else {
                    this.$root.$notify.show(`Nuevo Plan Asignado correctamente`, { color: 'success', x: 'left' });
                    if (result.enrollment_id) {
                      vue.msg = 'plan generado exitosamente, ID: ' + result.enrollment_id;
                      sessionStorage.removeItem('xpreinscrito');
                      sessionStorage.removeItem('xinscritotoplan');
                      vue.$router.back();
                    } else if (result.result) {
                      vue.msg = 'plan generado exitosamente.';
                      sessionStorage.removeItem('xpreinscrito');
                      sessionStorage.removeItem('xinscritotoplan');
                      vue.$router.back();
                    } else {
                      vue.msg = 'ERROR: ' + result;
                    }
                  }
                  vue.loading = false;
                });
            })
            .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
        } else {
          fetch(urlacademico, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              // window.console.log('GENERAPLAN:',result);
              if (!result) {
                vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO Generar el plan.';
              } else if (result.error) {
                vue.msg = result.error;
              } else {
                this.$root.$notify.show(`Plan Generado correctamente`, { color: 'success', x: 'left' });
                if (result.enrollment_id) {
                  vue.msg = 'plan generado exitosamente, ID: ' + result.enrollment_id;
                  sessionStorage.removeItem('xpreinscrito');
                  sessionStorage.removeItem('xinscritotoplan');
                  vue.$router.back();
                } else if (result.result) {
                  vue.msg = 'plan generado exitosamente.';
                  sessionStorage.removeItem('xpreinscrito');
                  sessionStorage.removeItem('xinscritotoplan');
                  vue.$router.back();
                } else {
                  vue.msg = 'ERROR: ' + result;
                }
              }
              vue.loading = false;
            })
            .catch(() => {
              // window.console.log('error', error);
              vue.loading = false;
            });
        }
      },
      formatCode(p) {
        if (this.programa && this.programa.postgrado) {
          return `${this.programa.postgrado.categoria.nombre.slice(0, 1)}-${this.programa.id}`.toUpperCase();
        }
        return p.codigo ? p.codigo : p.id;
      },
      marcarpagado(plan) {
        // window.console.log( plan );
        const opt = {
          okText: 'Continuar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        const message2 = {
          title: 'Confirmacion.',
          body:
            'Usted esta indicando que esta cuota ya fue pagada por el estudiante, debe indicar la fecha del pago realizado y definir las nuevas fechas de pago, caso contrario puede cancelar.',
        };
        this.$dialog
          .confirm(message2, opt)
          .then(function(dialog) {
            plan.saldo = 0;
            dialog.close();
          })
          .catch(function() {});
      },
      onnewregistro(data) {
        window.console.log('On New Reg: ', data);
      },
      cleanedstring(str, sinespacios = false) {
        if (!str) return str;
        str = str.toLowerCase();
        str = str.replace(/ +/g, ' ');
        str = str.replace(/á/gi, 'a');
        str = str.replace(/é/gi, 'e');
        str = str.replace(/í/gi, 'i');
        str = str.replace(/ó/gi, 'o');
        str = str.replace(/ú/gi, 'u');
        str = str.replace(/ñ/gi, 'n');
        if (sinespacios) str = str.replace(/ +/g, '');
        return str;
      },
      generateaccess(input) {
        let iniciala = '';
        let inicialb = '';
        let user = '';
        let pass = '';
        input.nombres = this.cleanedstring(input.nombres);
        input.primer_apellido = this.cleanedstring(input.primer_apellido, true);
        input.segundo_apellido = this.cleanedstring(input.segundo_apellido, true);
        let nombres = input.nombres.split(' ');
        iniciala = nombres[0].substring(0, 1);
        if (nombres[1]) inicialb = nombres[1].substring(0, 1);
        pass = input.numero_documento;
        user += iniciala + inicialb + input.primer_apellido.toLowerCase();
        if (input.segundo_apellido) user += input.segundo_apellido.toLowerCase();
        if (input.departamento) pass += input.departamento.extension;
        //let time = new Date().getTime().toString();
        //user += '-' + time.substring(time.length - 5);
        return { username: user, password: pass };
      },
      /*
      Obtiene a la persona, verificar si tiene usuario y clave moodle
      Si no tiene se actualiza creando su usuario y clave
      Esto porque desde el formulario de preinscripcion no lo crea**/
      xactualizarpersona(idpersona) {
        const url = `${process.env.VUE_APP_API_REST}/esam/persona/id/${idpersona}`;
        xaxios.get(url).then(({ data }) => {
          window.console.log('getdata:::', data.persona, idpersona);
          if (data && !data.persona.usuario_moodle) {
            let acc = this.generateaccess(data.persona);
            let idciudad = 1;
            let idpais = 1;
            let iddepartamento = 1;
            let idprofesiones = [];
            if (data.persona.ciudad) idciudad = data.persona.ciudad.id;
            if (data.persona.pais) idpais = data.persona.pais.id;
            if (data.persona.departamento) iddepartamento = data.persona.departamento.id;
            if (data.persona.profesiones)
              idprofesiones = data.persona.profesiones.map((x) => {
                return x.id;
              });
            else idprofesiones = [3];
            if (!data.persona.sexo) data.persona.sexo = 'M';
            if (!data.persona.estado_civil) data.persona.estado_civil = 'S';
            let input = {
              num_doc: data.persona.numero_documento,
              nombres: data.persona.nombres,
              pri_apellido: data.persona.primer_apellido,
              email: data.persona.email,
              sexo: data.persona.sexo,
              tipo: data.persona.tipo,
              diestro: true,
              iddepartamento: iddepartamento,
              idpais: idpais,
              idciudad: idciudad,
              est_civil: data.persona.estado_civil,
              telefono1: data.persona.telefono1,
              seg_apellido: data.persona.segundo_apellido,
              usuario_moodle: acc.username,
              clave_moodle: acc.password,
              id: data.persona.id,
              profesiones: idprofesiones,
            };
            window.console.log('Actualizando persona....', input);

            const sql = gql`mutation{updatePersona(input:${window.stringifyObject(input)}){ ok,  errors{message}}}`;
            this.$apollo
              .mutate({ mutation: sql })
              .then((data) => {
                if (!data.data) data.data = {};
                let updatePersona = data.data.updatePersona;
                window.console.log(updatePersona);
                if (!updatePersona || !updatePersona.ok) {
                  let txt = `NO SE PUDO ACTUALIZAR PERSONA: (Inscripcionrest-add.vue) \n\n ${JSON.stringify(input)}`;
                  fetch(
                    'https://api.telegram.org/bot1780932396:AAER4sTDMHBpWkiS66wVZVN9TenE7wUZ9Mg/sendMessage?chat_id=293911327&text=' +
                      txt,
                  )
                    .then((response) => response.json())
                    .then((data) => {
                      window.console.log(data);
                    });
                }
              })
              .catch((err) => {
                window.console.error(err);
              });
          }
        });
      },
      getPromo(idprograma) {
        this.loading_promo = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/programa/${idprograma}/aprobado`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('promo >>>> ', data);
            vue.xpromos = data;
            if (vue.xpromos.length == 1) vue.xpromo = vue.xpromos[0];
            vue.loading_promo = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading_promo = false;
          });
      },
    },
    mounted() {
      let cambiopreinscrito = sessionStorage.getItem('xpreinscrito');
      let generarplaninscrito = sessionStorage.getItem('xinscritotoplan');
      let xpro = sessionStorage.getItem('xprograma');

      //window.console.log("VISTA DE INS :>", cambiopreinscrito, generarplaninscrito,xpro);
      if (cambiopreinscrito) {
        this.isgenerarplan = cambiopreinscrito.estado_ins == 1;
        this.ispreinscribir = true;
        this.ispreinscrito = JSON.parse(cambiopreinscrito);
        // window.console.log( 'CAMBIO PREINSCRITO',this.ispreinscrito );
      } else if (!cambiopreinscrito && generarplaninscrito) {
        // correcion de vista
        this.isgenerarplan = true;
      }
      if (generarplaninscrito) {
        //this.isgenerarplan = true;
        this.ispreinscrito = JSON.parse(generarplaninscrito);
        // window.console.log( 'GENERAR PLAN INSCRITO',this.ispreinscrito );
      }
      window.console.log('<>XREST<>: ', this.ispreinscrito);

      if (xpro) {
        // tambien se usa en AexcelInscribirProgramas.vue
        var ob1 = JSON.parse(xpro);
        if (!isNullObject(ob1)) {
          this.remote_plan = ob1 && ob1.plan_pagos ? ob1.plan_pagos : [];
          // window.console.log('mounted line 573:  ',this.remote_plan);
          this.programa = ob1;
          //quitar esto, es solo test
          //window.console.log('prooooo', this.programa);
          if (this.programa.estudiante_id) this.xactualizarpersona(this.programa.estudiante_id);
        }
      }
      if (cambiopreinscrito) {
        var ob = JSON.parse(cambiopreinscrito);
        if (!isNullObject(ob)) this.inscripcion = ob;
      }
      if (isNullObject(ob1)) {
        this.$notify(error('Error', 'No existe el programa seleccionado, vuelva atras y seleccione uno.'));
      }
      if (this.programa) {
        this.inscripcionrest.programa_id = this.programa.id;
        this.getprogramarest(this.programa.id);
      }
      var ats = window.sessionStorage.route_ins;
      if (ats) this.atras = ats;

      this.lisCuotas();
    },
  };
</script>

<style></style>
